import React, { useEffect, useRef, useState } from "react";
import { spLogin } from "../../services/login";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Template from "../../components/SignInPageComponents/Template";
import LoadingAnimation from "../../assets/LoadingAnimation.svg";

const Signin = () => {
  const navigate = useNavigate();
  const ssoInitialized = useRef(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const scriptUrl = "https://app.servicepoints.nl/assets/js/sso.js";

    const setupSSO = () => {
      window._callbackSPLogin = response => {
        if (response?.data?.token && response.data._callback) {
          window.location.href = `${response.data._callback}?token=${response.data.token}`;
        }
      };

      const tryRenderButton = () => {
        const container = document.querySelector(".sp_login_btn");
        if (container && !ssoInitialized.current) {
          container.innerHTML = "";
          console.log("Rendering custom SSO button...");

          if (typeof window.createSPSignInButton === "function") {
            // Patch the original function to prevent double render
            const originalFn = window.createSPSignInButton;
            window.createSPSignInButton = () => {
              const innerContainer = document.querySelector(".sp_login_btn");
              if (innerContainer && innerContainer.children.length === 0) {
                originalFn(); // run only if no buttons yet
              }
            };
            window.createSPSignInButton();
            ssoInitialized.current = true;
            return true;
          }
        }
        return false;
      };

      // Retry logic in case of incognito or delay in availability
      let attempts = 0;
      const maxAttempts = 10;
      const interval = setInterval(() => {
        if (tryRenderButton() || attempts >= maxAttempts) {
          clearInterval(interval);
        }
        attempts++;
      }, 1000);
    };

    // Load the script if not already present
    if (!document.querySelector(`script[src="${scriptUrl}"]`)) {
      const script = document.createElement("script");
      script.src = scriptUrl;
      script.async = true;
      script.onload = setupSSO;
      document.body.appendChild(script);
    } else {
      setupSSO();
    }

    return () => {
      window._callbackSPLogin = null;
    };
  }, []);

  // Function to handle the SP_callback
  const handleSPCallback = async token => {
    if (token) {
      setLoading(true);
      try {
        await spLogin(token);

        // Redirect to the homepage or another page after successful login
        navigate("/");
      } catch (error) {
        toast.error(`${error.response?.data?.detail || error.response?.data?.error || "An unexpected error occurred"}`);
      } finally {
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get("token");
    if (token) {
      handleSPCallback(token);
    }
  }, [navigate]);

  return (
    <Template
      title="Login to your account"
      description="Or login with"
      formType="signin"
      className="flex justify-center"
    >
      {/* Centered Login Button */}
      <div className="relative z-10 flex justify-center items-center h-full">
        {loading ? (
          <img src={LoadingAnimation} alt="Loading..." className="h-full w-12 lg:w-20" />
        ) : (
          <div className="sp_login_btn" data-testid="sp_login_btn"></div>
        )}
      </div>
    </Template>
  );
};

export default Signin;
